import Repository from '@/libs/axios'

const serviceTypeResource = '/admin/settings/service-type'

export default {
  getServiceTypes(pageNumber = 1, pagination = 20) {
    return Repository.get(`${serviceTypeResource}?page=${pageNumber}&paginate=${pagination}`)
  },
  getServiceTypesNoPagination() {
    return Repository.get(`${serviceTypeResource}?noPagination`)
  },
  createServiceType(payload) {
    return Repository.post(`${serviceTypeResource}`, payload)
  },
  changeStatus(id, isActive) {
    return Repository.put(`${serviceTypeResource}/change-status?id=${id}`, {
      is_active: isActive,
    })
  },
  getLinkedRateCards(id, pageNumber = 1, pagination = 20) {
    return Repository.get(`${serviceTypeResource}/linked-rate-cards?id=${id}&page=${pageNumber}&paginate=${pagination}`)
  },
  getServiceTypeDropdown() {
    return Repository.get(`${serviceTypeResource}/dropdown-list`)
  },
}
